import util from './apiUtil.js'
import baseUrl from './url.js'

let api = {};
let newUrl = 'http://b.ganzhiyu.com/newgzy';

// 获取用户
api.getUser = function(cnt, callback) {
	util.call(baseUrl + '/paper/getUser', cnt, callback)
}
// 删除用户投稿
api.delPaper = function(cnt, callback) {
	util.call(baseUrl + '/paper/delPaper', cnt, callback)
}
// 获取投稿文档列表
api.getPaperList = function(cnt, callback) {
	util.call(baseUrl + '/paper/getPaperList', cnt, callback)
}
// 修改论文
api.updatePaper = function(cnt, callback) {
	util.call(baseUrl + '/paper/updatePaper', cnt, callback)
}

// 创建论文
api.createPaper = function(cnt, callback) {
	util.call(baseUrl + '/paper/createPaper', cnt, callback)
}

// 获取内容列表
api.getContentList = function(cnt, callback) {
	util.call(baseUrl + '/content/getContentList', cnt, callback)
}

// 注册接口
api.register = function(cnt, callback) {
	util.call(newUrl + '/UserInfect/register', cnt, callback);
}


// 登录接口
api.login = function(cnt, callback) {
	util.call(newUrl + '/UserInfect/login', cnt, callback);
}

// 判断用户信息
api.judgeUser = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/judgeUser', cnt, callback);
}
// 获取js_api ticket 
api.getJsapiTicket = function(cnt, callback) {
	util.call(baseUrl + '/wx/getJsapiTicket', cnt, callback)
}

// 获取直播间链接
api.getLiveUrl = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/getLiveUrl', cnt, callback)
}
// 加入直播间
api.joinLive = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/joinLive', cnt, callback)
}
// 团队注册
api.readExcelRegister = function(cnt, callback) {
	util.call(baseUrl + '/team/readExcelRegister', cnt, callback)
}
// 发送验证码
api.sendSms = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/sendSms', cnt, callback)
}
// 验证码登录
api.loginByCode = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/loginByCode', cnt, callback)
}
// 获取直播列表
api.getLiveList = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/getLiveList', cnt, callback)
}
// 追加聊天内容
api.appendMsg = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/appendMsg', cnt, callback)
}
// 获取聊天内容
api.getMsg = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/getMsg', cnt, callback)
}
// 感染学会获取第三方直播链接
api.getUserLiveUrl = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/getUserLiveUrl', cnt, callback)
}
//获取支付链接
api.pay = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/pay', cnt, callback);
}
//修改用户信息
api.updateUser = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/updateUser', cnt, callback);
}
//获取订单列表
api.getPayOrderInfectList = function(cnt, callback) {
	util.call(newUrl + '/UserInfect/getPayOrderInfectList', cnt, callback);
}

// 获取选择直播列表
api.getTimeTagList = function(cnt, callback) {
	util.call(baseUrl + '/infectLive/getTimeTagList', cnt, callback)
}
// 注销登录
api.exit = function(cnt, callback) {
	util.call(baseUrl + '/UserInfect/exit', cnt, callback)
}
export default api
